// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserTag__wrapper___2nMnX"};